// extracted by mini-css-extract-plugin
export default {"animation":"Animation_animation__Manyy","fade-in":"Animation_fade-in__SZy74","text":"Animation_text__Y91eq"};